import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalClose() {
  return <section className="w-full bg-[#1A1A2E] py-8 md:py-14 px-4" data-id="element-46">
      <div className="max-w-3xl mx-auto text-center" data-id="element-47">
        <p className="text-xl md:text-2xl text-white/90 mb-4" data-id="element-48">
          Puedes pasar otro año "intentando"…
        </p>
        <p className="text-xl md:text-2xl text-white mb-6" data-id="element-49">
          o puedes empezar hoy con un sistema que te obliga a practicar lo que
          sí se usa.
        </p>
        <p className="text-2xl md:text-3xl font-bold text-[#FF6B00] mb-3" data-id="element-50">
          Menos reglas. Más acción.
        </p>
        <p className="text-3xl md:text-4xl font-extrabold text-white mb-6" data-id="element-51">
          Inglés en Acción.
        </p>
        <CTAButton text="SÍ, QUIERO MI MEGAPACK (ARS $19.990)" data-id="element-52" />
      </div>
    </section>;
}